export const IframeResize = {
  mounted() {
    this.handler = (event) => {
      if (event.source !== this.el.contentWindow) return;

      const data = event.data;
      if (data && data.height) {
        this.el.style.height = `${data.height}px`;
      }
    };

    window.addEventListener("message", this.handler);
  },
  destroyed() {
    window.removeEventListener("message", this.handler);
  },
};
